// Guide/GuideCard.tsx

import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {IGuide} from '../../Types/psychology/guide';
import {FC, FR} from 'WideLayout/Layouts';
import {useTheme} from 'Theme/ThemeContext';

interface GuideCardProps {
    guide: IGuide;
}

const GuideCard: React.FC<GuideCardProps> = ({guide}) => {
    const {plt} = useTheme();
    const location = useLocation();
    const linkTo = location.pathname.includes('cabinet')
        ? `/cabinet/guide/${guide.id}`
        : `/guide/${guide.id}`;
    return (
        <FC
            p={2}
            cursorPointer
            cls={'hover-scale-4'}
            rounded={3}
            maxW={350}
            bg={`${plt.colors.secondary.light}33`}
            color={plt.text.primary80}
        >
            <Link
                to={linkTo}
                style={{color: plt.text.primary80}}
                className="text-decoration-none flex-grow-1"
            >
                <FC g={1} h={'100%'}>
                    <FC>
                        <h5>{guide.name}</h5>
                        <p style={{whiteSpace: 'pre-wrap'}}>{guide.description}</p>
                    </FC>
                    <FC mt={'auto'}>
                        {!guide.accessed && guide.is_public && (
                            <FR
                                rounded={3}
                                my={1}
                                cls={'text-nowrap'}
                                w={'min-content'}
                                px={1}
                                fontWeight={500}
                                bg={`${plt.colors.secondary.light}aa`}
                                color={plt.text.primary60}
                            >
                                Бесплатно сейчас!
                            </FR>
                        )}
                        {guide.accessed && (
                            <FR
                                rounded={3}
                                my={1}
                                cls={'text-nowrap'}
                                w={'min-content'}
                                px={1}
                                fontWeight={500}
                                bg={`${plt.colors.secondary.main}aa`}
                                color={'#fff'}
                            >
                                Доступен вам
                            </FR>
                        )}
                    </FC>
                </FC>
            </Link>
        </FC>
    );
};

export default GuideCard;
